import { IconWrapper } from '../runtime';
export default IconWrapper('house', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M13.6576 5.04976L8.90762 1.43976C8.37121 1.03208 7.62879 1.03208 7.09238 1.43976L2.34238 5.04976C1.96915 5.33341 1.75 5.77523 1.75 6.244V13.95C1.75 14.1157 1.88431 14.25 2.05 14.25H5.96698C6.12329 14.25 6.25 14.1233 6.25 13.9669V11C6.25 10.0335 7.0335 9.24996 8 9.24996C8.9665 9.24996 9.75 10.0335 9.75 11V13.9669C9.75 14.1233 9.87671 14.25 10.033 14.25H13.95C14.1157 14.25 14.25 14.1157 14.25 13.95V6.244C14.25 5.77523 14.0308 5.33341 13.6576 5.04976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});